export enum ComplianceDocumentTypeEnum {
    SignedContract = 41,
    BackgroundCheck = 59,
    ReleaseAuthorization = 45,
    BackgroundCheckAccessControl = 57233,
    BackgroundCheckLocums = 18012,
    Housing = 50,
    BackgroundReleaseAuthorization = 19155,
    PerDiemReleaseAuthorization = 76571
}

export enum ComplianceHealthDocumentTypeEnum {
    PhysicalExamTravel = 29,
    NegativeTBorChestXRayTravel = 30,
    TBQuestionnaireTravel = 31,
    RubeolaMeaslesTravel = 32,
    MumpsTravel = 33,
    RubellaTravel = 34,
    HepatitisBTravel = 35,
    VaricellaTravel = 36,
    DrugTestingTravel = 37,
    MedicalAndEmployeeInformationReleaseFormTravel = 61,
    TetanusDiphtheriaTdapTravel = 65,
    HepatitisATravel = 90,
    FitMaskTravel = 92,
    HepatitisCTravel = 256,
    ChainOfCustodyFormTravel = 649,
    FluSeasonalVaccinationDocumentation202526Travel = 766,
    CBCAndBiochemPanelTravel = 2358,
    PolioVaccineTravel = 2528,
    SmallpoxTravel = 2887,
    EyeExamTravel = 3055,
    ColorBlindExamTravel = 3385,
    LatexTiterTravel = 5944,
    NicotineTiterTravel = 15002,
    MiscHealthDocumentTravel = 16640,
    NegativeTBorChestXRayLocums = 18002,
    FluSeasonalVaccinationDocumentation202526Locums = 18003,
    RubeolaMeaslesLocums = 18004,
    MumpsLocums = 18005,
    RubellaLocums = 18006,
    VaricellaLocums = 18007,
    HepatitisBLocums = 18008,
    TetanusDiphtheriaTdapLocums = 18009,
    DrugTestingLocums = 18284,
    PhysicalLocums = 18285,
    FitTestLocums = 18286,
    TBQuestionnaireLocums = 19154,
    LatexQuestionnaireTravel = 19376,
    HepatitisCLocums = 20275,
    AdditionalVaccineOrReTiterTravel = 22249,
    COVID19ScreeningQuestionnaireTravel = 22554,
    COVID19ScreeningQuestionnaireLocums = 22917,
    COVID19TestingResultsTravel = 24002,
    COVID19VaccineDose1Travel = 28791,
    COVID19VaccineDose1Locums = 29073,
    COVID19VaccineFullyVaccinatedDose2Travel = 29544,
    DONOTUSECOVID19DeclinationTravel = 31890,
    COVIDTravel = 32680,
    COVID19ExemptionMedicalTravel = 32825,
    COVID19VaccineFullyVaccinatedDose2IfApplicableLocums = 33412,
    COVID19TestingResultsLocums = 33413,
    DONOTUSECOVID19DeclinationLocums = 33414,
    COVIDSeasonalVaccinationDocumentation202526Locums = 33415,
    COVID19ExemptionMedicalLocums = 33416,
    COVID19VaccineBoosterTravel = 33695,
    COVID19ExemptionReligiousTravel = 34240,
    COVID19VaccineExemptionAttestationCompletedByAgencyTravel = 35145,
    FluVaccineExemptionAttestationCompletedByAgencyTravel = 37456,
    COVID19ExemptionReligiousLocums = 37762,
    COVID19VaccineExemptionAttestationCompletedByAgencyLocums = 37763,
    COVID19VaccineBoosterLocums = 37764,
    COVID19VaccineBooster2Travel = 47236,
    COVID19VaccineBooster2Locums = 47237,
    PhysicalExamAccessControl = 57151,
    NegativeTBorChestXRayAccessControl = 57152,
    RubeolaMeaslesAccessControl = 57154,
    MumpsAccessControl = 57155,
    RubellaAccessControl = 57156,
    HepatitisBAccessControl = 57157,
    VaricellaAccessControl = 57158,
    DrugTestingAccessControl = 57159,
    TetanusDiphtheriaTdapAccessControl = 57212,
    FluSeasonalVaccinationDocumentation202526AccessControl = 57217,
    COVID19VaccineDose1AccessControl = 57226,
    COVID19VaccineFullyVaccinatedDose2IfApplicableAccessControl = 57227,
    DONOTUSECOVID19DeclinationAccessControl = 57228,
    COVID19ExemptionMedicalAccessControl = 57229,
    COVID19ExemptionReligiousAccessControl = 57230,
    COVID19VaccineBoosterAccessControl = 57231,
    COVID19VaccineBooster2AccessControl = 57232,
    RespSafetyClearanceTravel = 57729,
    TBQuestionnaireAccessControl = 59375,
    FitMaskAccessControl = 59955,
    AdditionalVaccineOrReTiterAccessControl = 60644,
    ColorBlindExamAccessControl = 62128,
    BreathalyzerTestTravel = 62186,
    HearingExamTravel = 62187,
    UrinalysisTravel = 62188,
    MeningococcalMeningitisVaccineTravel = 62189,
    PneumoniaVaccinationTravel = 62190,
    MiscHealthDocumentAccessControl = 62575,
    ColorBlindExamLocums = 62698,
    DrugTestingSalivaScreeningTravel = 65569,
    DrugTestingSalivaScreeningLocums = 65570,
    DrugTestingSalivaScreeningAccessControl = 65571,
    COVIDAccessControl = 68632,
    MMRAttestationTravel = 69772,
    VaricellaAttestationTravel = 69773,
    PendingDrugScreenAttestationTravel = 69774,
    LatexQuestionnaireLocums = 72996,
    DrugTestingAttestationTravel = 73609,
    DrugTestingAttestationLocums = 73610,
    DrugTestingAttestationAccessControl = 73611,
    RespSafetyClearanceLocums = 74083,
    HepatitisALocums = 75776,
    MeningococcalMeningitisVaccineLocums = 76538,
    MMRAttestationLocums = 76650,
    VaricellaAttestationLocums = 76651,
    PendingDrugScreenAttestationLocums = 76652
}
